import { NgClass, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'primeng/api';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { ImageComponent, OfferLabelComponent } from '../../foundation';

@Component({
  standalone: true,
  selector: 'lx-option-card',
  templateUrl: './option-card.component.html',
  styleUrls: ['./option-card.component.scss'],
  imports: [SharedModule, RadioButtonModule, FormsModule, NgIf, CheckboxModule, NgSwitch, NgSwitchCase, ImageComponent, OfferLabelComponent, NgClass],
})
export class OptionCardComponent<T> implements OnChanges {
  @Input() type: 'info' | 'checkbox' | 'radio' | 'weeks' = 'info';
  @Input() label = '';
  @Input() title = '';
  @Input() withImage = true;
  @Input() image = '';
  @Input() fallbackImage = '';
  @Input() option: T = null;
  @Input() selectedOption: T;
  @Output() selectedOptionChanged = new EventEmitter<T>();

  protected ariaRole: string | null = null;
  protected ariaChecked: boolean | null = null;

  ngOnChanges({ type, selectedOption, option }: SimpleChanges): void {
    if (type || selectedOption || option) {
      this.updateComputedProperties();
    }
  }

  updateSelection(selectedValue: T): void {
    if (this.type === 'info') {
      return;
    }
    this.selectedOption = selectedValue;
    this.selectedOptionChanged.emit(this.selectedOption);
  }

  private updateComputedProperties(): void {
    switch (this.type) {
      case 'radio':
        this.ariaRole = 'radio';
        this.ariaChecked = this.selectedOption === this.option;
        break;
      case 'checkbox':
        this.ariaRole = 'checkbox';
        this.ariaChecked = !!this.selectedOption;
        break;
      default:
        this.ariaRole = null;
        this.ariaChecked = null;
    }
  }
}
